import { Dispatch, FC, SetStateAction, useState } from 'react';
import { IconButton, SxProps, TableCell, Theme, styled, tableCellClasses } from '@mui/material';
import { SortType } from '../../../types/AlertType';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        textAlign: 'center',
        fontSize: 11,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 11,
        textAlign: 'center',
        color: "#fff"
    },
}));

interface SortData {
    id: number
    tittle: string;
    property?: string;
    toSort: boolean;
    width?: number;
}

interface TabSortProps {
    column: SortData;
    icon: any;
    sortedColumn: number;
    setSortParams: (column: string, order: SortType) => void;
    setSortedColumn: Dispatch<SetStateAction<number>>;
    style?: SxProps<Theme>;
}

const TabSort: FC<TabSortProps> = ({
    column,
    icon,
    sortedColumn,
    setSortParams,
    setSortedColumn
}) => {
    const [iconUp, setIconUp] = useState<boolean>(true);

    const handleSort = () => {
        if (column?.property) {
            let isIconUp = iconUp;
            let order: SortType = "ASC";

            if (sortedColumn === column.id) {
                order = isIconUp ? "DESC" : "ASC";
                setIconUp(!isIconUp);
            } else {
                setIconUp(iconUp);
                setSortedColumn(column.id);
            }
            setSortParams(column?.property, order);
        }
    };

    const col = column?.toSort ? (
        <IconButton
            onClick={() => handleSort()}
            sx={{ color: "#fff", fontSize: 11, width: column?.width }}
        >
            {icon}
            {column.tittle}
        </IconButton>
    ) : (
        <IconButton sx={{ color: "#fff", fontSize: 11, width: column?.width }}>
            {column.tittle}
        </IconButton>
    );

    return <StyledTableCell>{col}</StyledTableCell>;
};

export default TabSort;
